// This file is manually curated to allow us to expose the generated
// client as we like.
import type { Auth, Asset, AssetService, Realm, Scope, Export, SyncService } from "./gen";

export const MessageKind = {
  Asset: "assets.v3.Asset",
  AvailableRealmWithNames: 'realm.v3.AvailableRealmWithNames',
  CompleteAssetUploadRequest: "assets.v3.CompleteAssetUploadRequest",
  CreateAssetRequest: "assets.v3.CreateAssetRequest",
  GetAssetsRequest: "assets.v3.GetAssetsRequest",
  IncrementalSyncRequest: 'sync.v3.IncrementalRequest',
  UploadAssetRequest: "assets.v3.UploadAssetRequest",
  RealmWithNames: "realm.v3.RealmWithNames",
  SyncRequest: "auth.v3.SyncRequest",
  Scope: "query.v3.Scope",
  ExportRichTextRequest: "export.v3.ExportRichTextRequest",
};

// =============================================================================
// AUTH
// =============================================================================
export function createSyncRequest(data: Partial<Omit<Auth.SyncRequest, "$typeName">> = {}): Auth.SyncRequest {
  return {
    $typeName: MessageKind.SyncRequest,
    ...data,
  } as Auth.SyncRequest;
}

// =============================================================================
// ASSETS
// =============================================================================

// Factory to create a type safe Asset to be used in the client
export function createAsset(data: Partial<Omit<Asset.Asset, "$typeName">> = {}): Asset.Asset {
  return {
    $typeName: MessageKind.Asset,
    ...data,
  } as Asset.Asset;
}

export function createCompleteAssetUploadRequest(
  data: Partial<Omit<AssetService.CompleteAssetUploadRequest, "$typeName">> = {},
): AssetService.CompleteAssetUploadRequest {
  return {
    $typeName: MessageKind.CompleteAssetUploadRequest,
    ...data,
  } as AssetService.CompleteAssetUploadRequest;
}

export function createCreateAssetRequest(
  data: Partial<Omit<AssetService.CreateAssetRequest, "$typeName">> = {},
): AssetService.CreateAssetRequest {
  return {
    $typeName: MessageKind.CreateAssetRequest,
    ...data,
  } as AssetService.CreateAssetRequest;
}

export function createGetAssetsRequest(
  data: Partial<Omit<AssetService.GetAssetsRequest, "$typeName">> = {},
): AssetService.GetAssetsRequest {
  return {
    $typeName: MessageKind.GetAssetsRequest,
    ...data,
  } as AssetService.GetAssetsRequest;
}

export function createUploadAssetRequest(
  data: Partial<Omit<AssetService.UploadAssetRequest, "$typeName">> = {},
): AssetService.UploadAssetRequest {
  return {
    $typeName: MessageKind.UploadAssetRequest,
    ...data,
  } as AssetService.UploadAssetRequest;
}

// =============================================================================
// REALMS
// =============================================================================
export function createRealmWithNames(
  data: Partial<Omit<Realm.RealmWithNames, "$typeName">> = {},
): Realm.RealmWithNames {
  return {
    $typeName: MessageKind.RealmWithNames,
    ...data,
  } as Realm.RealmWithNames;
}

// =============================================================================
// Chat
// =============================================================================
export function createScope(data: Partial<Omit<Scope.Scope, "$typeName">> = {}): Scope.Scope {
  return {
    $typeName: MessageKind.Scope,
    ...data,
  } as Scope.Scope;
}

// =============================================================================
// EXPORT
// =============================================================================
export function createExportRichTextRequest(
  data: Partial<Omit<Export.ExportRichTextRequest, "$typeName">> = {},
): Export.ExportRichTextRequest {
  return {
    $typeName: MessageKind.ExportRichTextRequest,
    ...data,
  } as Export.ExportRichTextRequest;
}

// =============================================================================
// Sync
// =============================================================================
export function createIncrementalSyncRequest(
  data: Partial<Omit<Scope.Scope, '$typeName'>> = {}
): SyncService.IncrementalRequest {
  return {
    $typeName: MessageKind.IncrementalSyncRequest,
    ...data,
  } as SyncService.IncrementalRequest
}
